import { SearchCase, SearchOperator } from "./search.types";

export const EXPORT_FORMATS = {
    EXCEL: 'excel',
    CSV: 'csv',
    PDF : 'pdf'
} as const;

export type ExportFilter = {
    value: any;
    operator: SearchOperator,
    case: SearchCase,
    label: string
}

export type BlogData = {
    blob: Blob;
    filename: any;
}

export type ExportParams<VM> = {
    context? : Record<string, any>,
    filters?: Record<keyof VM, ExportFilter>;
    sorting?: [{ column: string; order: 'asc' | 'desc' }];
};

export const EXPORT_TYPES = {
    DOWNLOAD : 'download', 
    GENERATE : 'generate'
 } as const;

export type ExportType = typeof EXPORT_TYPES[keyof typeof EXPORT_TYPES];